import React from 'react';
import '../styles/JoinGymDialog.css';

interface JoinGymDialogProps {
  gymName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const JoinGymDialog: React.FC<JoinGymDialogProps> = ({ gymName, onConfirm, onCancel }) => {
  const handleOverlayClick = (e: React.MouseEvent) => {
    // Only close if clicking the overlay itself, not the dialog content
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  const handleCloseClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent overlay click handler
    onCancel();
  };

  const handleCancelClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent overlay click handler
    onCancel();
  };

  const handleConfirmClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent overlay click handler
    onConfirm();
  };

  return (
    <div className="join-gym-overlay" onClick={handleOverlayClick}>
      <div className="join-gym-dialog">
        <div className="dialog-header">
          <h3>Join Gym</h3>
          <button className="close-button" onClick={handleCloseClick} type="button">×</button>
        </div>
        <p>Would you like to join <strong>{gymName}</strong>?</p>
        <p className="join-info">
          Joining this gym will add it to your favorites and make it easier to log climbs here.
        </p>
        <div className="join-gym-actions">
          <button 
            onClick={handleCancelClick}
            className="cancel-button"
          >
            Not Now
          </button>
          <button 
            onClick={handleConfirmClick}
            className="confirm-button"
          >
            Join Gym
          </button>
        </div>
      </div>
    </div>
  );
};

export default JoinGymDialog;
